<div class="vtr-widget-offline-tip">
	<img id="widget-offline-tip-img" [src]="'assets/icons/icon-wifi-slash.svg' | svgInline | async">
	<p id="widget-offline-tip-text" role="text">{{'common.connection.no-internet-tip' | translate}}</p>
</div>